<ng-container>
  <app-button class="mr-3"
              *ngIf="itemId"
              buttonStyle="danger-outlined"
              [fullWidth]="false"
              (click)="openDeleteConfirmPopup()">
    {{ 'delete' | t }}
  </app-button>

  <app-button buttonStyle="action"
              [fullWidth]="false"
              (click)="saveItem.emit()">
    {{ 'save' | t }}
  </app-button>
</ng-container>

<ng-template #deletePopup>
  <app-delete-popup (delete)="deleteItem.emit()"
                    [mainText]="mainDeleteTextLangVar | t"
                    [helperText]="helperDeleteTextLangVar | t">
  </app-delete-popup>
</ng-template>
